<template>
  <v-app>
    <v-container fluid class="pa-0 fill-height d-flex">
      <v-row no-gutters class="fill-height">
        <v-col cols="12" md="4" class="left-side d-flex justify-center">
          <h1 class="white--text main-title">
            {{ $t("completeInfo.headline") }}
          </h1>
        </v-col>

        <v-col
          cols="12"
          md="8"
          class="right-side d-flex align-center justify-center"
        >
          <v-card class="form-card" elevation="0">
            <v-card-title class="d-flex align-center justify-center">
              <v-img
                src="@/assets/images/connect/customer/connect-logo.webp"
                contain
                height="250"
              ></v-img>
            </v-card-title>
            <v-card-text style="min-height: 55vh">
              <p class="text-center grey--text mb-2 px-4">
                {{ $t("completeInfo.intro") }}
              </p>
              <v-form
                ref="form"
                v-model="valid"
                elevation="0"
                @submit.prevent="nextStep"
              >
                <v-stepper
                  v-model="step"
                  class="stepper"
                  elevation="0"
                  style="max-width: 100%"
                >
                  <v-stepper-header
                    elevation="0"
                    class="d-flex align-center justify-center"
                  >
                    <span class="grey--text poppins">Let's do it!</span>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 1"
                      step="1"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 2"
                      step="2"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 3"
                      step="3"
                    ></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      elevation="0"
                      :complete="step > 4"
                      step="4"
                    ></v-stepper-step>
                  </v-stepper-header>
                  <v-stepper-items elevation="0">
                    <v-stepper-content step="1">
                      <v-card-text>
                        <h6 class="grey--text">
                          {{ $t("completeInfo.step1") }}
                        </h6>
                        <p class="mt-2">
                          <strong class="grey--text">A.</strong>
                          <strong class="primary900 poppins">{{
                            $t("completeInfo.goalQ")
                          }}</strong
                          ><br />
                          <span class="primary900">{{
                            $t("completeInfo.goalHint")
                          }}</span>
                        </p>
                        <v-row dense>
                          <v-radio-group
                            v-model="details.mainGoal"
                            row
                            :rules="[
                              (v) => !!v || $t('completeInfo.selectOption'),
                            ]"
                          >
                            <v-col cols="12" md="6">
                              <v-radio
                                :label="$t('completeInfo.professional')"
                                value="PROFESSIONAL"
                              ></v-radio>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-radio
                                :label="$t('completeInfo.communication')"
                                value="COMMUNICATION"
                              ></v-radio>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-radio
                                :label="$t('completeInfo.trips')"
                                value="TRIPS"
                              ></v-radio>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-radio
                                :label="$t('completeInfo.others')"
                                value="OTHERS"
                              ></v-radio>
                            </v-col>
                          </v-radio-group>
                        </v-row>
                      </v-card-text>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-stepper v-model="subStep">
                        <v-stepper-items>
                          <v-stepper-content step="1">
                            <v-card-text>
                              <h6 class="grey--text">
                                {{ $t("completeInfo.step2a") }}
                              </h6>
                              <p class="mt-2">
                                <strong class="grey--text">A.</strong>
                                <strong class="primary900 poppins">{{
                                  $t("completeInfo.preferenceQ")
                                }}</strong>
                              </p>
                              <v-row dense>
                                <v-radio-group
                                  v-if="step === 2 && subStep === 1"
                                  v-model="details.preference"
                                  column
                                  :rules="[
                                    (v) =>
                                      !!v || $t('completeInfo.selectOption'),
                                  ]"
                                >
                                  <v-radio
                                    class="mt-1"
                                    :label="$t('completeInfo.alone')"
                                    value="ALONE"
                                  ></v-radio>
                                  <v-radio
                                    class="mt-1"
                                    :label="$t('completeInfo.withTeacher')"
                                    value="WITH_TEACHER"
                                  ></v-radio>
                                </v-radio-group>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="2">
                            <v-card-text>
                              <h6 class="grey--text">
                                {{ $t("completeInfo.step2") }}
                              </h6>
                              <p class="mt-2">
                                <strong class="grey--text">B.</strong>
                                <strong class="primary900 poppins">{{
                                  $t("completeInfo.perWeekQ")
                                }}</strong>
                              </p>
                              <v-row dense>
                                <v-radio-group
                                  v-if="step === 2 && subStep === 2"
                                  v-model="details.perWeek"
                                  column
                                  :rules="[
                                    (v) =>
                                      !!v || $t('completeInfo.selectOption'),
                                  ]"
                                >
                                  <v-radio
                                    class="mt-1"
                                    label="1"
                                    value="ONCE"
                                  ></v-radio>
                                  <v-radio
                                    class="mt-1"
                                    label="2"
                                    value="TWICE"
                                  ></v-radio>
                                  <v-radio
                                    class="mt-1"
                                    label="3+"
                                    value="THREE_OR_MORE"
                                  ></v-radio>
                                  <v-radio
                                    class="mt-1"
                                    :label="$t('completeInfo.biweekly')"
                                    value="EACH_15_DAYS"
                                  ></v-radio>
                                </v-radio-group>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="3">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">
                                {{ $t("completeInfo.step2") }}
                              </h6>
                              <p class="mt-2">
                                <strong class="grey--text">C.</strong>
                                <strong class="primary900 poppins">{{
                                  $t("completeInfo.modalityQ")
                                }}</strong>
                              </p>
                              <v-row dense>
                                <v-col
                                  cols="12"
                                  md="6"
                                  v-for="(goal, index) in types"
                                  :key="index"
                                  class="d-flex align-center justify-start"
                                >
                                  <v-checkbox
                                    v-if="step === 2 && subStep === 3"
                                    v-model="details.formatGoal"
                                    :value="goal.value"
                                    :label="goal.text"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                              <v-row dense v-if="displayError">
                                <small style="color: #ea2626">{{
                                  $t("completeInfo.selectAtLeastOne")
                                }}</small>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="4">
                            <v-card-text>
                              <h6 class="grey--text">
                                {{ $t("completeInfo.step2") }}
                              </h6>
                              <p class="mt-2">
                                <strong class="grey--text">D.</strong>
                                <strong class="primary900 poppins">{{
                                  $t("completeInfo.hoursQ")
                                }}</strong>
                              </p>
                              <v-row dense>
                                <v-radio-group
                                  v-if="step === 2 && subStep === 4"
                                  v-model="details.availableHours"
                                  column
                                  :rules="[
                                    (v) =>
                                      !!v || $t('completeInfo.selectOption'),
                                  ]"
                                >
                                  <v-radio
                                    class="mt-1"
                                    label="1:00"
                                    value="1:00"
                                  ></v-radio>
                                  <v-radio
                                    class="mt-1"
                                    label="1:30"
                                    value="1:30"
                                  ></v-radio>
                                </v-radio-group>
                              </v-row>
                              <p class="mt-4">
                                <strong class="grey--text">E.</strong>
                                <strong class="primary900 poppins">{{
                                  $t("completeInfo.budgetQ")
                                }}</strong>
                              </p>
                              <v-row dense>
                                <v-col cols="6" md="4">
                                  <v-text-field
                                    v-model.number="details.budgetMin"
                                    :label="$t('completeInfo.min')"
                                    prefix="R$"
                                    type="number"
                                    min="0"
                                    dense
                                    outlined
                                    hide-details
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="6" md="4">
                                  <v-text-field
                                    v-model.number="details.budgetMax"
                                    :label="$t('completeInfo.max')"
                                    prefix="R$"
                                    type="number"
                                    min="0"
                                    dense
                                    outlined
                                    hide-details
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                        </v-stepper-items>
                      </v-stepper>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                      <v-stepper v-model="subStep">
                        <v-stepper-items>
                          <v-stepper-content step="1" dense>
                            <v-card-text elevation="0">
                              <h6 class="grey--text">
                                {{ $t("completeInfo.step3") }}
                              </h6>
                              <p class="mt-2">
                                <strong class="grey--text">A.</strong>
                                <strong class="primary900 poppins">{{
                                  $t("completeInfo.scaleQ")
                                }}</strong>
                              </p>
                              <v-row no-gutters align="center" justify="center">
                                <v-col cols="12" md="4">
                                  <i18n
                                    path="completeInfo.watchWith"
                                    tag="span"
                                    class="poppins grey--text"
                                  >
                                    <template #strong>
                                      <strong style="color: #32352c">{{
                                        $t("completeInfo.with")
                                      }}</strong>
                                    </template>
                                  </i18n>
                                </v-col>
                                <v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    required
                                    row
                                    class="ml-3"
                                    v-model="details.watchWithSub"
                                    :rules="[
                                      (v) =>
                                        !!v || $t('completeInfo.selectOption'),
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row dense align="center" justify="center">
                                <v-col cols="12" md="4">
                                  <i18n
                                    path="completeInfo.watchWith"
                                    tag="span"
                                    class="poppins grey--text"
                                  >
                                    <template #strong>
                                      <strong style="color: #32352c">{{
                                        $t("completeInfo.without")
                                      }}</strong>
                                    </template>
                                  </i18n> </v-col
                                ><v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    row
                                    class="ml-3"
                                    v-model="details.watchWithoutSub"
                                    :rules="[
                                      (v) =>
                                        !!v || $t('completeInfo.selectOption'),
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row dense align="center" justify="center">
                                <v-col cols="12" md="4">
                                  <span class="poppins grey--text">{{
                                    $t("completeInfo.understandConversation")
                                  }}</span></v-col
                                >
                                <v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    row
                                    class="ml-3"
                                    v-model="details.understanding"
                                    :rules="[
                                      (v) =>
                                        !!v || $t('completeInfo.selectOption'),
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row dense align="center" justify="center">
                                <v-col cols="12" md="4"
                                  ><span class="poppins grey--text">{{
                                    $t("completeInfo.communicate")
                                  }}</span></v-col
                                >
                                <v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    row
                                    class="ml-3"
                                    v-model="details.communication"
                                    :rules="[
                                      (v) =>
                                        !!v || $t('completeInfo.selectOption'),
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row dense align="center" justify="center">
                                <v-col cols="12" md="4">
                                  <span class="poppins grey--text">{{
                                    $t("completeInfo.read")
                                  }}</span></v-col
                                >
                                <v-col cols="12" md="8">
                                  <v-radio-group
                                    v-if="step === 3 && subStep === 1"
                                    row
                                    class="ml-3"
                                    v-model="details.reading"
                                    :rules="[
                                      (v) =>
                                        !!v || $t('completeInfo.selectOption'),
                                    ]"
                                  >
                                    <v-radio
                                      v-for="i in 11"
                                      :key="i"
                                      :value="i"
                                      :label="(i - 1).toString()"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="2">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">
                                {{ $t("completeInfo.step3") }}
                              </h6>
                              <p class="mt-2">
                                <strong class="grey--text">B.</strong>
                                <strong class="primary900 poppins">{{
                                  $t("completeInfo.contactQ")
                                }}</strong>
                                <v-row dense class="mt-2">
                                  <v-col
                                    cols="12"
                                    md="4"
                                    v-for="(learningWay, index) in learningWays"
                                    :key="index"
                                    class="d-flex align-center justify-start"
                                  >
                                    <v-checkbox
                                      v-if="step === 3 && subStep === 2"
                                      v-model="details.mainContacts"
                                      :value="learningWay.value"
                                      :label="$t(learningWay.label)"
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                                <v-row dense v-if="displayError">
                                  <small style="color: #ea2626">{{
                                    $t("completeInfo.selectAtLeastOne")
                                  }}</small>
                                </v-row>
                              </p>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="3">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">
                                {{ $t("completeInfo.step3") }}
                              </h6>
                              <p class="mt-2">
                                <strong class="grey--text">C.</strong>
                                <strong class="primary900 poppins">{{
                                  $t("completeInfo.areaQ")
                                }}</strong>
                              </p>
                              <v-row dense>
                                <v-col
                                  cols="12"
                                  md="4"
                                  v-for="(area, index) in currentAreas"
                                  class="d-flex align-center justify-start"
                                  :key="index"
                                >
                                  <v-checkbox
                                    v-model="details.currentAreas"
                                    :value="area.value"
                                    :label="$t(area.label)"
                                  ></v-checkbox>
                                </v-col>
                              </v-row>
                              <v-row dense v-if="displayError">
                                <small style="color: #ea2626">{{
                                  $t("completeInfo.selectAtLeastOne")
                                }}</small>
                              </v-row>
                            </v-card-text>
                          </v-stepper-content>
                          <v-stepper-content step="4">
                            <v-card-text elevation="0">
                              <h6 class="grey--text">
                                {{ $t("completeInfo.step3goals") }}
                              </h6>
                              <p class="mt-2">
                                <strong class="grey--text">D.</strong>
                                <strong class="primary900 poppins">{{
                                  $t("completeInfo.goalMessageQ")
                                }}</strong>
                              </p>
                              <v-col cols="12" md="9">
                                <v-textarea
                                  outlined
                                  solo
                                  :placeholder="
                                    $t('completeInfo.messagePlaceholder')
                                  "
                                  v-model="details.message"
                                  v-if="step === 3 && subStep === 4"
                                  rows="6"
                                ></v-textarea>
                              </v-col>
                            </v-card-text>
                          </v-stepper-content>
                        </v-stepper-items>
                      </v-stepper>
                    </v-stepper-content>

                    <v-stepper-content step="4">
                      <v-card-text elevation="0">
                        <h6 class="grey--text">
                          {{ $t("completeInfo.step4") }}
                        </h6>
                        <p class="mt-2">
                          <strong class="grey--text">A.</strong>
                          <strong class="primary900 poppins">{{
                            $t("completeInfo.availabilityQ")
                          }}</strong>
                        </p>
                        <v-row dense>
                          <v-col cols="12" md="12">
                            <WeeklyTable
                              ref="weeklyTable"
                              v-if="step === 4"
                              style="width: 100%"
                              :inAHalf="true"
                              :values="available"
                              :perClass="perClass"
                          /></v-col>
                        </v-row>
                        <v-row dense align="center" justify="start">
                          <span v-if="hourAlert" style="color: crimson">{{
                            $t("completeInfo.duplicated")
                          }}</span>
                        </v-row>
                      </v-card-text>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-col cols="12" md="6">
                <div class="d-flex flex-column fill-width">
                  <v-btn
                    v-if="!(step === 1 && subStep === 1)"
                    outlined
                    @click="prevStep"
                    x-large
                    class="grey--text fill-width"
                    >{{ $t("common.back") }}</v-btn
                  >
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex flex-column fill-width">
                  <v-btn
                    @click="nextStep"
                    color="#b51f57"
                    x-large
                    class="white--text"
                    :loading="loading"
                    >{{
                      step === 4
                        ? $t("completeInfo.finish")
                        : $t("completeInfo.next")
                    }}</v-btn
                  >
                </div>
              </v-col>
            </v-card-actions>
            <div class="d-flex align-center justify-center">
              <CopyRight />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import customerApi from "@/shared/pitchCustomerApi";
import CopyRight from "@/components/CopyRight.vue";
import WeeklyTable from "@/components/connect/WeeklyTable.vue";

export default {
  name: "CompleteInfo",
  components: { CopyRight, WeeklyTable },
  data() {
    return {
      loading: false,
      valid: false,
      hourAlert: false,
      displayError: false,
      step: 1,
      subStep: 1,
      details: {
        mainGoal: null,
        preference: null,
        perWeek: null,
        formatGoal: [],
        availableHours: null,
        watchWithSub: null,
        watchWithoutSub: null,
        understanding: null,
        communication: null,
        reading: null,
        mainContacts: [],
        currentAreas: [],
        message: null,
        budgetMin: null,
        budgetMax: null,
      },
      available: [{ weekDay: null, from: null, to: null }],
      // O valor é o texto que a API grava (em português); só o rótulo segue
      // o idioma da tela.
      learningWays: [
        { value: "Música", label: "completeInfo.way.music" },
        { value: "Filmes e Séries", label: "completeInfo.way.movies" },
        { value: "Livros", label: "completeInfo.way.books" },
        { value: "Estudos", label: "completeInfo.way.studies" },
        { value: "Trabalho", label: "completeInfo.way.work" },
        { value: "Outras Formas", label: "completeInfo.way.other" },
        { value: "Amigos", label: "completeInfo.way.friends" },
        { value: "Redes Sociais", label: "completeInfo.way.social" },
      ],
      currentAreas: [
        { value: "Estudante", label: "completeInfo.area.student" },
        { value: "Educação", label: "completeInfo.area.education" },
        { value: "Comércio", label: "completeInfo.area.commerce" },
        { value: "Tecnologia", label: "completeInfo.area.technology" },
        { value: "Saúde", label: "completeInfo.area.health" },
        { value: "Outros", label: "completeInfo.area.others" },
      ],
    };
  },
  computed: {
    types() {
      return [
        { text: this.$t("enums.groupFormat.1"), value: "INDIVIDUAL" },
        { text: this.$t("enums.groupFormat.2"), value: "DUO" },
        { text: this.$t("enums.groupFormat.3"), value: "TRIO" },
        { text: this.$t("enums.groupFormat.4"), value: "SQUAD" },
      ];
    },
    perClass() {
      return this.details.availableHours === "1:30" ? 90 : 60;
    },
  },
  methods: {
    verifyDuplicated(horarios) {
      const seen = new Set();
      let hasDuplicated = false;
      horarios.forEach((horario) => {
        const chave = `${horario.weekDay}-${horario.from}-${horario.to}`;
        if (seen.has(chave)) {
          hasDuplicated = true;
        }
        seen.add(chave);
      });
      return hasDuplicated;
    },
    nextStep() {
      if (this.step === 4) {
        const items = this.$refs.weeklyTable.getData();
        const validHours = items.filter((h) => h && h.weekDay !== null);
        if (validHours.length && this.verifyDuplicated(validHours)) {
          this.hourAlert = true;
          return;
        }
        this.hourAlert = false;
        this.available = validHours;
        this.submit();
      } else if (this.step === 2 && this.details.preference === "ALONE") {
        // Aluno sozinho: nao precisa de aulas por semana/horas nem formato.
        this.details.perWeek = 0;
        this.details.availableHours = 0;
        this.details.formatGoal = "ALONE";
        this.subStep = 1;
        this.step++;
      } else if (this.step === 2 || this.step === 3) {
        this.nextSubStep();
      } else if (this.$refs.form.validate()) {
        this.step++;
      }
    },
    nextSubStep() {
      if (
        this.step === 2 &&
        this.subStep === 3 &&
        this.details.formatGoal.length === 0
      ) {
        this.displayError = true;
      } else if (
        this.step === 2 &&
        this.subStep < 4 &&
        this.$refs.form.validate()
      ) {
        this.displayError = false;
        this.subStep++;
      } else if (
        this.step === 3 &&
        this.subStep < 4 &&
        this.$refs.form.validate()
      ) {
        if (this.subStep === 2 && this.details.mainContacts.length === 0) {
          this.displayError = true;
          return;
        } else if (
          this.subStep === 3 &&
          this.details.currentAreas.length === 0
        ) {
          this.displayError = true;
          return;
        }
        this.displayError = false;
        this.subStep++;
      } else if (this.$refs.form.validate()) {
        this.displayError = false;
        // Aluno "Sozinho" (ALONE) não informa disponibilidade: finaliza o
        // cadastro após o passo 3, sem passar pelo passo 4 (card 86ajb61hq).
        if (this.step === 3 && this.details.preference === "ALONE") {
          this.available = [];
          this.submit();
          return;
        }
        this.subStep = 1;
        this.step++;
      }
    },
    prevStep() {
      if (this.step === 1) return;
      if (this.step === 2 || this.step === 3 || this.step === 4) {
        return this.previousSubStep();
      }
      this.step--;
    },
    previousSubStep() {
      this.displayError = false;
      if (this.step === 2 && this.subStep === 1) {
        this.step--;
      } else if (this.step === 2 && this.subStep > 1) {
        this.subStep--;
      } else if (this.step === 3 && this.subStep === 1) {
        this.step--;
        // Se for "Sozinho", o passo 2 so teve o subStep 1.
        this.subStep = this.details.preference === "ALONE" ? 1 : 4;
      } else if (this.step === 3 && this.subStep > 1) {
        this.subStep--;
      } else if (this.step === 4) {
        this.step--;
        this.subStep = 4;
      }
    },
    // Lê do perfil o que a API gravou. Se a consulta falhar, cai na conversão
    // local — errar a aba do menu é bem menos grave do que segurar o aluno na
    // porta por causa de uma consulta a mais.
    async resolveSavedPreference() {
      try {
        const { data } = await customerApi.showProfile();
        if (data?.preference != null) return data.preference;
      } catch {
        // segue para a conversão local
      }

      return this.details.preference === "ALONE" ? 1 : 2;
    },
    async submit() {
      const details = { ...this.details };
      // Remove orcamento vazio/invalido para nao falhar na validacao numerica.
      ["budgetMin", "budgetMax"].forEach((field) => {
        const value = details[field];
        if (value === "" || value === null || Number.isNaN(Number(value))) {
          delete details[field];
        }
      });

      this.loading = true;
      try {
        await customerApi.completePersonalInfo({
          details,
          available: this.available,
        });

        // Cadastro deixou de estar pendente: atualiza o store e libera a
        // plataforma.
        //
        // Card 86akfyjht: a `preference` precisa entrar junto. O menu esconde o
        // grupo "Turmas" do aluno sem professor lendo esse campo do store, e o
        // store só era reescrito no login — por isso a aba "Minhas Turmas"
        // aparecia no primeiro acesso e sumia no segundo.
        //
        // Quem dá a resposta é a API, não o formulário: o perfil recém-salvo
        // traz `preference` já convertida (e o nível calculado junto).
        const user = this.$store.getters.user || {};
        const preference = await this.resolveSavedPreference();

        this.$store.commit("SET_USER", {
          ...user,
          pendingInfo: false,
          preference,
        });

        this.$root.$emit("display-alert", {
          text: this.$t("completeInfo.saved"),
          type: 0,
        });

        // Card 86akj7g9k: terminar o cadastro leva direto para a escolha de
        // professor/turma (o MatchExplorer, na aba "Plano de estudos"), e não
        // para o dashboard vazio.
        //
        // O aluno solo é a exceção que o próprio guard já faz: `beforeEach`
        // manda quem tem `preference === 1` de /turmas para /curso porque não
        // há fluxo de match para ele. Acabou de dizer que quer estudar
        // sozinho; cai nos módulos.
        //
        // `Number(...)` porque `preference` vem da API, e coluna int chega
        // como string aqui -- comparar direto falharia em silêncio.
        //
        // Por caminho, não por nome: "Curso" e "Perfil" existem nas rotas do
        // professor e do aluno, e o nome resolve para a do professor (a
        // primeira registrada) -- o aluno era deslogado ao chegar lá.
        this.$router.push(
          Number(preference) === 1
            ? { path: "/connect/aluno/curso" }
            : // Card 86akj7g9k (retorno de 09/10): o match fica em Turmas.
              { path: "/connect/aluno/turmas" }
        );
      } catch (err) {
        const raw = err?.response?.data?.message || "";
        const message = Array.isArray(raw) ? raw.join(" ") : raw;
        this.$root.$emit("display-alert", {
          text: message || this.$t("completeInfo.saveFailed"),
          type: 1,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.fill-height {
  height: 100vh;
}

.left-side {
  background-image: url("../../assets/images/connect/customer/background-min.webp");
  background-size: cover;
  background-position: center;
  color: white;

  h1 {
    margin-top: 15vh;
  }
}

.right-side {
  padding: 24px;
  display: flex;
}

.form-card {
  width: 100%;
  height: 100%;
}

.primary900 {
  color: var(--dk-pink-deep, #6b1233);
}

.primary700 {
  color: var(--dk-pink-deep, #b51f57);
}

strong {
  font-size: 16px;
}
</style>
